import script from "./DynamicFormTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicFormTable.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicFormTable.vue?vue&type=style&index=0&id=0e8646f8&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8646f8"]])

export default __exports__